import React from "react";

interface DeleteProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    selectedRecord: any;
    reloading: () => void;
}

const DeleteDatePattern: React.FC<DeleteProps> = ({ open, setOpen, selectedRecord, reloading }) => {
    return (
        <div>
            {/* Delete Date Pattern Dialog Content */}
        </div>
    );
}

export { DeleteDatePattern };